import NotificationsCenterManage from './NotificationsCenterManage'

export default NotificationsCenterManage
// eslint-disable-next-line import/export
export * from './NotificationsCenterManage'
